import styled from '@emotion/styled';
import { BREAKPOINTS_LEGACY, COLORS } from '@sortlist-frontend/design-system/legacy';

export const ScrollingLocations = styled.div`
  @media only screen and (min-width: ${BREAKPOINTS_LEGACY.sm}) {
    max-height: 16rem;
  }
`;

export const MapContainer = styled.div`
  min-height: 10rem;
  @media only screen and (max-width: ${BREAKPOINTS_LEGACY.xs}) {
    height: 30rem;
  }
`;

export const LocationIcon = styled.div`
  top: 0;
`;

export const Location = styled.div`
  @media only screen and (min-width: ${BREAKPOINTS_LEGACY.sm}) {
    &:hover > div {
      background-color: ${COLORS.SECONDARY_200};
    }
  }
`;

export const SocialIcon = styled.img`
  height: 1em;
  width: 1em;
  opacity: 0.75;
`;

export const EmptyDiv = styled.div`
  width: 640px;
`;
